<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to employee list" @click="$router.go(-1)">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-chip v-if="!loading&&isDeactivatedUser" outline>
                        <v-icon color="grey">person_off</v-icon>&nbsp;&nbsp;<span class="white--text" title="This account has been deactivated already">Deactivated</span>
                    </v-chip>
                    <help-link appId="payroll" pageId="annualization" color="white"></help-link>
                    <v-btn v-show="hasAnnualization" @click="showReportsMenu" dark icon small title="Print Reports">
                        <v-icon>fa-solid fa-file</v-icon>
                    </v-btn>
                    <v-menu v-if="!loading&&hasEditAndApprover" left v-model="menu_status" offset-y :disabled="disabledForEditAndApprover"> 
                        <template v-slot:activator="{ on }">
                            <v-btn v-show="!hasAnnualization" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Not Created&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="createdStatus" v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Created&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="forReviewStatus" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;For Review&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="approvedStatus" color="green darken-2" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Approved&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="rejectedStatus" color="red" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Rejected&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="adjustmentsProcessedStatus" color="primary" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Adjustments Processed&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-show="periodCount>0">
                            <v-list-tile v-show="hasEditAndApprover&&!hasAnnualization" :key="0" @click="compuateAnnualization" title="Compute Annualization">
                                <v-list-tile-title small>Process</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditAndApprover&&(createdStatus||rejectedStatus)" :key="1" @click="compuateAnnualization" title="Regenerate Annualization">
                                <v-list-tile-title small>Reprocess</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditAndApprover&&createdStatus" :key="2" @click="setForReview" title="Set For Review">
                                <v-list-tile-title small>Set For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditAndApprover&&(forReviewStatus||rejectedStatus)" :key="3" @click="approve" title="Approve Annualization">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditAndApprover&&(forReviewStatus||approvedStatus)" :key="4" @click="reject" title="Reject Annualization">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="approvedStatus&&finalAdjustments>0" :key="5" @click="adjustmentsProcessed" title="Set status to Adjustments Processed">
                                <v-list-tile-title small>Adjustments Processed</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <v-menu v-if="!loading&&!hasEditAndApprover&&(hasEditRights||hasApproverRights)" left v-model="menu_status" offset-y :disabled="disableMenuEditRights||disableMenuApproverRights"> 
                        <template v-slot:activator="{ on }">
                            <v-btn v-show="!hasAnnualization" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Not Created&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="createdStatus" v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Created&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="forReviewStatus" color="orange" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;For Review&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="approvedStatus" color="green darken-2" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Approved&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="rejectedStatus" color="red" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Rejected&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                            <v-btn v-show="adjustmentsProcessedStatus" color="primary" dark v-on="on" :loading="loading_status">
                                &nbsp;&nbsp;Adjustments Processed&nbsp;&nbsp;
                                <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense v-show="periodCount>0">
                            <v-list-tile v-show="hasEditRights&&!hasAnnualization" :key="0" @click="compuateAnnualization" title="Compute Annualization">
                                <v-list-tile-title small>Generate</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&(createdStatus||rejectedStatus)" :key="1" @click="compuateAnnualization" title="Regenerate Annualization">
                                <v-list-tile-title small>Regenerate</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasEditRights&&createdStatus" :key="2" @click="setForReview" title="Set For Review">
                                <v-list-tile-title small>Set For Review</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReviewStatus||rejectedStatus)" :key="3" @click="approve" title="Approve Annualization">
                                <v-list-tile-title small>Approve</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="hasApproverRights&&(forReviewStatus||approvedStatus)" :key="4" @click="reject" title="Reject Annualization">
                                <v-list-tile-title small>Reject</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile v-show="approvedStatus&&finalAdjustments>0" :key="5" @click="adjustmentsProcessed" title="Set status to Adjustments Processed">
                                <v-list-tile-title small>Adjustments Processed</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </v-toolbar>
                <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -3px 0px -3px;"></v-progress-linear>
            </v-card>

            <!-- alerts -->
            <div  v-if="!loading">
                <v-alert v-if="error" :value="true" color="error" icon="error" outline style="margin:10px 0px 10px 0px;">
                    Error encountered. Please contact support.
                </v-alert> 
                <v-alert v-if="hiredAndResigned" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    <b>{{annualization.user.firstName}} {{annualization.user.lastName}}</b> start date was <b>{{employment.startDate|moment('MMM DD, YYYY')}}</b> and resigned on <b>{{employment.endDate|moment('MMM DD, YYYY')}}</b>. Please review <b>Payroll History</b> to ensure consistency.
                </v-alert>
                <v-alert v-if="hiredThisYear&&!hiredAndResigned" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    <b>{{annualization.user.firstName}} {{annualization.user.lastName}}</b>' start date was <b>{{this.annualization.user.hireDate|moment('MMM DD, YYYY')}}</b> and expected to have incomplete payroll. Please review <b>Payroll History</b> to ensure consistency.
                </v-alert>
                <v-alert v-if="resignedOrTerminatedStatus&&!hiredAndResigned" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    <b>{{annualization.user.firstName}} {{annualization.user.lastName}}</b>' has <b>RESIGNED</b> on <b>{{employment.endDate|moment('MMM DD, YYYY')}}</b> and expected to have incomplete payroll. Please review <b>Payroll History</b> to ensure consistency.
                </v-alert>
                <v-alert v-if="resignedOrTerminatedStatus&&hasAnnualization" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    Please refer to the <b>Final Adjustments</b> section of the <b>Annualization Report</b> for the final pay of this employee.
                </v-alert>
                <v-alert v-if="!resignedOrTerminatedStatus&&approvedStatus&&finalAdjustments>=0" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    <b>Final Adjustments</b> will be reflected on the succeeding payroll. If you wish to credit <b>Final Adjustments</b> earlier than the next payroll, change status to <b>Adjustments Processed</b>.
                </v-alert>
                <v-alert v-if="!resignedOrTerminatedStatus&&approvedStatus&&finalAdjustments<0" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    <b>Additional Tax</b> will be deducted on succeeding payroll.
                </v-alert>
                <v-alert v-if="hasAnnualization" :value="true" color="info" icon="info" outline style="margin:5px 0px 5px 0px;">
                    To reflect this annualization in <b>1601-C</b> report, you must regenerate <b>1601-C</b> once this annualization has been approved.
                </v-alert>
                <v-alert v-if="hasUnapprovedPayroll" :value="true" color="warning" icon="warning" outline style="margin:5px 0px 5px 0px;">
                    There are unapproved payroll. Please review Payroll History section.
                </v-alert>
                <v-alert v-if="incompletePayroll&&!resignedOrTerminatedStatus&&!hiredThisYear&&!hiredAndResigned" :value="true" color="warning" icon="warning" outline style="margin:5px 0px 5px 0px;">
                    There are missing payroll. Please review Payroll History section.
                </v-alert>
                <v-alert v-if="periodCount==0" :value="true" color="warning" icon="warning" outline style="margin:5px 0px 5px 0px;">
                    No payroll found. Please review Payroll History section.
                </v-alert>
            </div>

            <v-expansion-panel v-if="!loading" v-model="panel" expand style="margin-top:5px;">
                <!-- EMPLOYEE -->
                <v-expansion-panel-content>
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-8px;':''">EMPLOYEE</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-card-text v-if="!loading && annualization!=null" >
                            <v-layout row wrap> 
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employee :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            <v-chip @click="viewUserProfile(annualization.user, $store.state.userId)" style="margin:-5px 0px 0px -5px;">
                                                <v-avatar>
                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(annualization.user.userId)"></v-img>
                                                </v-avatar>
                                                {{annualization.user.firstName}} {{annualization.user.lastName}}
                                            </v-chip>
                                        </v-flex>   
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employee Id : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{annualization.user.employeeId}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Pay Grade : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                        {{annualization.user.payGrade}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Position : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{annualization.user.position}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Hire Date :
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{annualization.user.hireDate | moment('MMM DD, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Employment Status : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{commonfn.getStatusDescription(employment.employmentStatus)}}
                                        </v-flex>  
                                    </v-layout>
                                    <v-layout v-if="employment.employmentStatus==commonfn.getStatusCode('Resigned')" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                        <v-flex xs4 class="text-xs-left">
                                            Last Working Day : 
                                        </v-flex>
                                        <v-flex xs8 class="font-weight-bold text-xs-left">
                                            {{employment.endDate|moment('MMM DD, YYYY')}}
                                        </v-flex>  
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- PAYROLL HISTORY -->
                <v-expansion-panel-content v-if="periodCount>0">
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-8px;':''">PAYROLL HISTORY</span> <!--FOR YEAR {{selectedYear}}-->
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent">
                        <v-data-table
                            :headers="headers"
                            :items="payroll_history"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr v-if="props.item.payrollStatus" style="cursor:pointer;" title="Click to view payroll details">
                                    <td @click="viewDetails(props.item)">{{props.item.startDate | moment('MMM DD, YYYY')}}</td>
                                    <td @click="viewDetails(props.item)">{{props.item.endDate | moment('MMM DD, YYYY')}}</td>
                                    <td @click="viewDetails(props.item)">
                                        <span v-if="props.item.payrollStatus!=commonfn.getStatusCode('Not Available')">{{numFormat.formatNumber(props.item.totalEarnings)}}</span>
                                    </td>
                                    <td @click="viewDetails(props.item)">
                                        <span v-if="props.item.payrollStatus!=commonfn.getStatusCode('Not Available')">{{numFormat.formatNumber(props.item.totalDeductions)}}</span>
                                    </td>
                                    <td @click="viewDetails(props.item)">
                                        <span v-if="props.item.payrollStatus!=commonfn.getStatusCode('Not Available')">{{numFormat.formatNumber(props.item.netPay)}}</span>
                                    </td>
                                    <td @click="viewDetails(props.item)">
                                        <span v-if="props.item.payrollStatus!=commonfn.getStatusCode('Not Available')">{{numFormat.formatNumber(props.item.taxWithheld)}}</span>
                                    </td>
                                    <td @click="viewDetails(props.item)"> 
                                        <span :class="commonfn.getStatusColor(props.item.payrollStatus)">{{commonfn.getStatusDescription(props.item.payrollStatus)}}</span>
                                    </td>
                                    <!-- 
                                    this can be replaced by pdfViewer instead of download
                                    <td>
                                        <v-btn v-if="props.item.payrollStatus!=commonfn.getStatusCode('Not Available')" @click="generatePayslipPDF(props.item, props.index)" icon :loading="loading_pdf[props.index].value" small title="View Payslip in PDF">
                                            <v-icon>fas fa-file-pdf</v-icon>
                                        </v-btn>
                                    </td> -->
                                </tr>
                                <tr v-else @click="viewPayrollGenerationMain(props.item)" class="font-weight-bold red--text" title="Missing payroll. Click to view Payroll Generation for this period." style="cursor:pointer;" >
                                    <td>{{props.item.startDate | moment('MMM DD, YYYY')}}</td>
                                    <td>{{props.item.endDate | moment('MMM DD, YYYY')}}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Not Generated</td>
                                    <td></td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-expansion-panel-content>

                <!-- LEAVES CONVERSION -->
                <v-expansion-panel-content v-if="hasAnnualization&&(annualization.details.slConversionAmount>0||annualization.details.vlConversionAmount>0)" >
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-8px;':''">LEAVES CONVERSION</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-card-text>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs8 class="text-xs-left"><h4>Leave Type</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Days</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                            </v-layout>
                            <v-layout v-if="annualization.details.slConversionAmount>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs8 class="text-xs-left">Sick Leave</v-flex>
                                <v-flex xs2 class="text-xs-right">{{annualization.details.slConvertedDays}}</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.slConversionAmount)}}</v-flex>
                            </v-layout>
                            <v-layout v-if="annualization.details.vlConversionAmount>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs8 class="text-xs-left">Vacation Leave</v-flex>
                                <v-flex xs2 class="text-xs-right">{{annualization.details.vlConvertedDays}}</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.vlConversionAmount)}}</v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- FINAL TAXABLE BENEFITS -->
                <v-expansion-panel-content v-if="hasAnnualization">
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-8px;':''">FINAL TAXABLE BENEFITS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-card-text >
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left"><h4>Benefit Type</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Total Amount</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Excess</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Taxable</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">Deminimis</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalDeminimisBenefits)}}</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalDeminimisBenefitsExcess)}}</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalDeminimisBenefitsExcess)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">Fringe Benefits</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalFringeBenefits)}}</v-flex>
                                <v-flex xs2 class="text-xs-right">N/A</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalFringeBenefits)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left">Other Benefits</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalOtherBenefits)}}</v-flex>
                                <v-flex xs2 class="text-xs-right">N/A</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalOtherBenefits)}}</v-flex>
                            </v-layout>
                             <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Sick Leave Conversion (Taxable)</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.slConversionAmount)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Vacation Leave Conversion</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.vlConversionAmount)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left font-italic">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Non Taxable Vacation Leave Conversion : {{numFormat.formatNumber(annualization.details.vlConversionAmountNonTaxable)}}</v-flex>
                                <v-flex xs2 class="text-xs-right font-italic"></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left font-italic">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Taxable Vacation Leave Conversion (excess of 10 days) : {{numFormat.formatNumber(annualization.details.vlConversionAmountTaxable)}}</v-flex>
                                <v-flex xs2 class="text-xs-right font-italic"></v-flex>
                            </v-layout>
                            <br>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left"><h4>Benefit Exemption</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4></h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4></h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.benefitsExemption)}}</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs6 class="text-xs-left"><h4>Final Taxable Benefits</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4></h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4></h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.finalTaxableBenefits)}}</h4></v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- FINAL TAX -->
                <v-expansion-panel-content v-if="hasAnnualization">
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-8px;':''">FINAL TAX COMPUTATION</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-card-text>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>EARNINGS TAX</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Taxable Benefits</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.finalTaxableBenefits)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Basic Salary</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalBasicSalary)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Overtime</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalOvertime)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Manual Adjustments (debit, taxable)</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalManualAdjustmentsDebitTaxable)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Manual Adjustments (debit, nontaxable)</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalManualAdjustmentsDebitNonTaxable)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Unpaid Leaves</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalUnpaidLeaves)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Unpaid Days</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalUnpaidDays)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Undertime</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalUndertime)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Night Differential</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalNightDiff)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Manual Adjustments (credit, taxable)</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalManualAdjustmentsCreditTaxable)}}</v-flex>
                            </v-layout>    
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Manual Adjustments (credit, nontaxable)</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalManualAdjustmentsCreditNonTaxable)}}</v-flex>
                            </v-layout>                           
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"></v-flex>
                                <v-flex xs2 class="text-xs-right"><hr></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Total Earnings Tax</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.totalEarnings)}}</h4></v-flex>
                            </v-layout>
                            <br>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>DEDUCTIONS</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total SSS Employee Contribution</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalSSSEmployeeContribution)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Pagibig Employee Contribution</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalPagibigEmployeeContribution)}}</v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Total Philhealth Employee Contribution</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.totalPhilhealthEmployeeContribution)}}</v-flex>
                            </v-layout>                            
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"></v-flex>
                                <v-flex xs2 class="text-xs-right"><hr></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Total Deductions</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.totalDeductions)}}</h4></v-flex>
                            </v-layout>
                            <br>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Final Taxable Income</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.finalTaxableIncome)}}</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Final Tax</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.finalTax)}}</h4></v-flex>
                            </v-layout>
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Total Tax Withheld</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(annualization.details.totalTaxWithheld)}}</h4></v-flex>
                            </v-layout>
                            <v-layout v-if="annualization.details.finalTaxAdjustments!=0&&!resignedOrTerminatedStatus" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">
                                    <h4 v-if="annualization.details.finalTaxAdjustments<0">Tax Refund
                                        <i class="caption">&nbsp;(to be credited on next payroll)</i>
                                    </h4>
                                    <h4 v-if="annualization.details.finalTaxAdjustments>0">Additional Tax
                                        <i  class="caption">&nbsp;(to be debited on next payroll)</i>
                                    </h4>
                                </v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(Math.abs(annualization.details.finalTaxAdjustments))}}</h4></v-flex>
                            </v-layout>
                            <v-layout v-if="annualization.details.finalTaxAdjustments!=0&&resignedOrTerminatedStatus" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">
                                    <h4>Tax Refund
                                        <i v-if="annualization.details.finalTaxAdjustments>0" class="caption"></i>
                                        <i v-if="annualization.details.finalTaxAdjustments<0" class="caption"></i>
                                    </h4>
                                </v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(Math.abs(annualization.details.finalTaxAdjustments))}}</h4></v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>

                <!-- FINAL ADJUSTMENTS -->
                <v-expansion-panel-content v-if="hasAnnualization">
                    <template v-slot:header>
                        <span class="font-weight-bold" :style="isMobile?'margin-left:-8px;':''">FINAL ADJUSTMENTS</span>
                        <v-spacer></v-spacer>
                    </template>
                    <v-card class="elavation-1 transparent"> 
                        <v-card-text>
                            <!-- header -->
                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Credit to Employee's Payroll</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                            </v-layout>

                            <!-- details -->
                            <v-layout v-if="annualization.details.slConversionAmount>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Sick Leaves Conversion</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.slConversionAmount)}}</v-flex>
                            </v-layout>
                            <v-layout v-if="annualization.details.vlConversionAmount>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Vacation Leaves Conversion</v-flex>
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.vlConversionAmount)}}</v-flex>
                            </v-layout>
                            <v-layout v-if="annualization.details.finalTaxAdjustments<0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Tax Refund</v-flex>
                                <!-- display absolute/positive value, in backend this is negative -->
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(Math.abs(annualization.details.finalTaxAdjustments))}}</v-flex>
                            </v-layout>
                             <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Total Credit to Employee's Payroll</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(totalFinalAdjustmentsCredit)}}</h4></v-flex>
                            </v-layout>
                            <br>

                            <!-- header -->
                            <v-layout v-if="annualization.details.finalTaxAdjustments>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>Debit to Employee's Payroll</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>Amount</h4></v-flex>
                            </v-layout>

                            <!-- details -->
                            <v-layout v-if="annualization.details.finalTaxAdjustments>0" row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left">Additional Tax</v-flex>
                                <!-- display absolute/positive value, in backend this is negative -->
                                <v-flex xs2 class="text-xs-right">{{numFormat.formatNumber(annualization.details.finalTaxAdjustments)}}</v-flex>
                            </v-layout>

                            <v-layout row wrap :class="isMobile?'section-layout-mobile':'section-layout'"> 
                                <v-flex xs10 class="text-xs-left"><h4>FINAL ADJUSTMENTS</h4></v-flex>
                                <v-flex xs2 class="text-xs-right"><h4>{{numFormat.formatNumber(finalAdjustments)}}</h4></v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Comments and Updates -->
            <v-layout row wrap>
                <v-flex xs12 sm6>
                    <!-- comments history component -->
                    <comments-history v-if="!loading" :comments_data="commentsData"></comments-history>
                </v-flex>
                <v-flex xs12 sm6>
                    <update-history v-if="!loading" ref="updateHistoryRef" :page_query_id="pageQueryId"></update-history>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-dialog v-model="dialogReports" persistent width="600">
            <reports ref="reportsRef" :dialogReports.sync="dialogReports"></reports>
        </v-dialog>
        <v-snackbar v-model="snackbar" :bottom="y === 'top'" :left="x === 'left'" :multi-line="mode === 'multi-line'"
            :right="x === 'right'" :timeout="6000" :top="y === 'top'" :vertical="mode === 'vertical'"
            >{{snackbarText}}
            <v-btn color="primary" flat @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <!-- status messaging component -->
        <status-messaging :page_query_id="pageQueryId" @refresh="updateHandler"></status-messaging>
    </v-layout> 
</template>

<script>

import annualizationApi from '@/api/annualization'
import commonfn from '@/common/functions'
import numFormat from '@/common/num_format'
import awsS3Helper from '@/helpers/aws-s3'
import pageKeys from '@/common/pagekeys'
import notificationTypes from '@/common/notificationTypes'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'Annualization',
    metaInfo: {
        title: 'Annualization',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'View/edit Annualization' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'reports': () => import('@/components/Annualization/AnnualizationReports'),
        'status-messaging': () => import('@/components/Common/StatusMessaging'),
        'update-history': () => import('@/components/Common/UpdatesHistory'),
        'comments-history': () => import('@/components/Common/CommentsHistory')
    },   
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            numFormat,
            mode:null,
            awsS3Helper,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            y: null,
            x: null,
            snackbar: false,
            snackbarText: '',
            dialogReports: false,
            loading_status: false,
            loading_annualization_pdf: false,
            expand: false,
            menu_status: false,
            message: null,
            headers: [
                {text: 'CutOff Start',align:'left', value:'startDate',width: '12%', sortable:true},
                {text: 'CutOff End',align:'left', value:'endDate',width: '12%', sortable:true},
                {text: 'Total Earnings',align:'left', value:'totalEarnings',width: '15%', sortable:true},
                {text: 'Total Deductions',align:'left', value:'totalDeductions',width: '15%', sortable:true},
                {text: 'Net Pay',align:'left', value: 'netPay',width: '15%', sortable:true},
                {text: 'Tax Witheld',align:'left', value: 'taxWithheld',width: '15%', sortable:true},
                {text: 'Payroll Status',align:'left', value: 'payrollStatus',width: '20%', sortable:true},
                // {text: 'Payslip',align:'left',value: '',  width: '5%', sortable:false},
            ],
            panel: [true],
            annualization: null,
            payroll_history: [],
            loading_pdf: [],
            employment: null,
        }
    },
    methods: {  
        showReportsMenu() {
            var data = {
                employeeName: `${this.annualization.user.firstName} ${this.annualization.user.lastName}`,
                fiscalPeriodId: this.fiscalPeriodId,
                selectedUserId: this.selectedUserId,
                fiscalYear: this.selectedYear,
                canPrint2316: this.approvedStatus || this.adjustmentsProcessedStatus
            }
            this.$refs.reportsRef.setParam(data)
            this.dialogReports=true
        },
        async adjustmentsProcessed() {
            //this will just update the status to Adjustments Processed
            try {
                this.loading_status = true
                var data = {
                    annualizationId: this.annualization.details.annualizationId
                }
                const response = await annualizationApi.adjustmentsProcessed(data)
                if (response.status==200) {
                    await this.getAnnualization(false)
                    this.snackbarText = `Status has been updated to Adjustments Processed.`
                    this.snackbar = true
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async approve() {
            try {
                this.loading_status = true
                var data = {
                    annualizationId: this.annualization.details.annualizationId
                }
                const response = await annualizationApi.approve(data)
                if (response.status==200) {
                    await this.getAnnualization(false)
                    this.snackbarText = `Annualization has been approved.`
                    this.snackbar = true
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async reject() {
            try {
                this.loading_status = true
                var data = {
                    annualizationId: this.annualization.details.annualizationId
                }
                const response = await annualizationApi.reject(data)
                if (response.status==200) {
                    await this.getAnnualization(false)
                    this.snackbarText = `Annualization has been rejected.`
                    this.snackbar = true
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async setForReview() {
            try {
                this.loading_status = true
                var data = {
                    annualizationId: this.annualization.details.annualizationId
                }
                const response = await annualizationApi.forReview(data)
                if (response.status==200) {
                    await this.getAnnualization(false)
                    this.snackbarText = `Annualization has been set to For Review.`
                    this.snackbar = true
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async compuateAnnualization() {
            try {
                this.loading_status = true
                var data = {
                    userId: this.selectedUserId,
                    fiscalPeriodId: this.fiscalPeriodId
                }
                const response = await annualizationApi.compute(data)
                if (response.status == 200) {
                    await this.getAnnualization(false)
                    this.snackbarText = `Annualization has been generated.`
                    this.snackbar = true
                }
                this.loading_status = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        viewPayrollGenerationMain(data) {
            this.$router.push(`/payroll/generate/${data.cutOffId}`)
        },
        viewUserProfile(data, loggedInUserId) {
            if (data.userId == loggedInUserId)
                this.$router.push(`/company/myprofile`)
            else 
                this.$router.push(`/hr/employees/${data.userId}`)
        },
        viewDetails(data) {
           this.$router.push(`/payroll/generate/${data.cutOffId}/${data.userId}`)
        },
        async getAnnualization(display_loading) {
            try {
                this.loading = display_loading
                const response = await annualizationApi.getByUser(this.fiscalPeriodId,this.selectedUserId)
                if (response && response.status == 200) {
                    this.employment = response.data.employment
                    this.annualization = response.data
                    this.payroll_history = response.data.payrollHistory
                    this.payroll_history.forEach(item => {
                        this.loading_pdf.push({
                            index: item.index,
                            value: false
                        })
                    })
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        getCoverageDesc(data) {
            return this.$moment(data.startDate).format('YYYY-MM-DD') + '-' + this.$moment(data.endDate).format('YYYY-MM-DD')
        },
        updateHandler(data) {
            //exclude the the device/user who initiates the update
            if (data!=this.$store.state.userId) this.getAnnualization(false)

            //invoke updateHistoryRef appendData 
            this.$refs.updateHistoryRef.getHistory()
        },
    },
    async created() {
        await this.getAnnualization(true)

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `Payroll Annualization ${this.selectedYear}`
        })
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        pageQueryId() {
            return `annualization-${this.fiscalPeriodId}-${this.selectedUserId}`
        },
        hasEditAndApprover() {
            return this.hasEditRights && this.hasApproverRights
        },
        hasEditRights() {
            return commonfn.hasEditRights(this.$router.currentRoute.path)
        },
        hasApproverRights() {
            return commonfn.hasApproverRights(this.$router.currentRoute.path)
        },
        selectedUserId() {
            return this.$route.params.userId
        },
        fiscalPeriodId() {
            return this.$route.params.fiscalPeriodId
        },
        commentsData() {
            if (!this.loading) {
                return {
                    pageQueryId: this.pageQueryId,
                    pageItemCreatedBy: null,
                    pageLink: this.$router.currentRoute.path,
                    pageKey: pageKeys.annualization,
                    notificationTypeId: notificationTypes.annualization_details
                }
            }
        },
        isMobile() {
            return window.innerWidth < 600
        },
        payrollUserName() {
            return `${this.annualization.user.firstName} ${this.annualization.user.lastName}`
        },
        payrollCount() {
            return this.payroll_history.filter(item => {
                return item.payrollStatus!=commonfn.getStatusCode('Not Available')
            }).length
        },
        periodCount() {
            return this.payroll_history.length
        },
        hasUnapprovedPayroll() {
            return this.payroll_history.filter(item => {
                //unapproved - created, for review, rejected
                return item.payrollStatus!=null && 
                        item.payrollStatus!=commonfn.getStatusCode('Approved') && 
                        item.payrollStatus!=commonfn.getStatusCode('Credited') &&
                        item.payrollStatus!=commonfn.getStatusCode('Published') && 
                        item.payrollStatus!=commonfn.getStatusCode('Not Available')
            }).length > 0
        },
        incompletePayroll() {
            return this.payrollCount<this.periodCount
        },
        totalTaxWithHeld() {
            return this.payroll_history.map(x => x.taxWithheld).reduce((prev,next) => prev+next)
        },
        selectedYear() {
            return this.annualization.user.fiscalYear
        },
        hasAnnualization() {
            if (this.annualization!=null) return this.annualization.details!=null
            return false;
        },
        createdStatus() {
            if (this.annualization!=null) {
                if (this.annualization.details!=null) 
                    return this.annualization.details.annualizationStatus==commonfn.getStatusCode('Created')
            }
            return false //not created
        },
        forReviewStatus() {
            if (this.annualization!=null) {
                if (this.annualization.details!=null) 
                    return this.annualization.details.annualizationStatus==commonfn.getStatusCode('For Review')
            }
            return false //not created
        },
        approvedStatus() {
            if (this.annualization!=null) {
                if (this.annualization.details!=null) 
                    return this.annualization.details.annualizationStatus==commonfn.getStatusCode('Approved')
            }
            return false //not created
        },
        rejectedStatus() {
            if (this.annualization!=null) {
                if (this.annualization.details!=null) 
                    return this.annualization.details.annualizationStatus==commonfn.getStatusCode('Rejected')
            }
            return false //not created
        },
        adjustmentsProcessedStatus() {
            if (this.annualization!=null) {
                if (this.annualization.details!=null) 
                    return this.annualization.details.annualizationStatus==commonfn.getStatusCode('Adjustments Processed')
            }
            return false //not created
        },
        resignedOrTerminatedStatus() {
            if (this.employment) {
                return this.employment.employmentStatus == commonfn.getStatusCode('Resigned') ||
                        this.employment.employmentStatus == commonfn.getStatusCode('Terminated')
            }
        },
        hiredThisYear() {
             if (this.annualization) 
                return this.annualization.user.hiredThisYear
        },
        hiredAndResigned() {
            return this.hiredThisYear && this.resignedOrTerminatedStatus
        },
        totalFinalAdjustmentsCredit() {
            //Total Final Adjustments (Credit)
            var taxAdjustments = this.annualization.details.finalTaxAdjustments<0 ? Math.abs(this.annualization.details.finalTaxAdjustments) : 0
            var total = this.annualization.details.slConversionAmount +
                        this.annualization.details.vlConversionAmount +
                        taxAdjustments
            return total
        },
        disableMenuEditRights() {
            return this.isDeactivatedUser ||
                    (
                        this.hasEditRights && 
                        (
                            this.hasUnapprovedPayroll||
                            this.forReviewStatus||
                            this.adjustmentsProcessedStatus||
                            (this.approvedStatus&&this.finalAdjustments<=0) ||
                            (this.incompletePayroll&&!this.resignedOrTerminatedStatus&&!this.hiredAndResigned&&!this.hiredThisYear)
                        )
                    )
        },
        disableMenuApproverRights() {
            return this.isDeactivatedUser ||
                    (
                        this.hasApproverRights && 
                        (
                            !this.hasAnnualization
                            ||this.hasUnapprovedPayroll
                            ||this.createdStatus
                            ||this.adjustmentsProcessedStatus
                        )
                    )
        },
        disabledForEditAndApprover() {
            return this.isDeactivatedUser ||
                    this.adjustmentsProcessedStatus ||
                    (this.approvedStatus&&this.finalAdjustments<=0) ||
                    (this.incompletePayroll&&!this.resignedOrTerminatedStatus&&!this.hiredAndResigned&&!this.hiredThisYear)
        },
        finalAdjustments() {
            //finalTaxAdjustments is negative in the backend if tax refund. If possitive, add'l tax
            return this.annualization.details.slConversionAmount +
                        this.annualization.details.vlConversionAmount -
                        this.annualization.details.finalTaxAdjustments
        },
        isDeactivatedUser() {
            return this.annualization.user.deactivated
        }
    }
}
</script>
<style scoped>
    .section-layout {
        padding:0px 20px 0px 50px;
    }
    .section-layout-mobile {
        padding:0px;
    }
</style>